import {SEARCH_ROUTE} from 'core/modules/routing/constants';
import {SearchUrlService} from 'plugins/modules/search/services/SearchUrlService';

export const getSearchPageLink = (searchValue: string) => {
    return `${SEARCH_ROUTE}/?${SearchUrlService.COMMON_PARAM_NAMES.QUERY}=${encodeURIComponent(searchValue)}`;
};
